module.exports = __webpack_public_path__ + "img/maforilogo.d58ecb1d.png";